<nb-card>
  <nb-card-header *ngIf="isPlaying">
    <button nbButton fullWidth size="small" (click)="stopPlay()">
      <nb-icon icon="pause-circle-outline"></nb-icon>
      <span>Tắt video</span>
    </button>
  </nb-card-header>

  <nb-card-body>
    <button
      *ngIf="!isPlaying"
      nbButton
      shape="round"
      size="small"
      status="danger"
      (click)="clickPlay()"
    >
      <nb-icon icon="play-circle-outline"></nb-icon>
      <span>Nhấn để xem</span>
    </button>

    <youtube-player
      #player
      *ngIf="isPlaying"
      [videoId]="videoId"
      (ready)="onReady()"
      (stateChange)="onStateChange($event)"
    ></youtube-player>
  </nb-card-body>
</nb-card>
